
import {Box} from "@mui/material";
import HeroSection from "../components/HeroSection";

export default function Home() {
    
    return (
        <Box sx={{ width: '100%', height: '800px' }}>
            <HeroSection/>
        </Box>
    );


}